import { create } from "zustand";

interface PersonalInfoFormState {
  personalInfoForm: {
    firstName: string;
    lastName: string;
    address: string;
    contactNumber: string;
    email: string;
    identificationNumber: string;
    policyNumber: string;
    identificationType: string;
  };
  setPersonalInfoForm: (data: any) => void;
  resetPersonalInfoForm: () => void;
}

export const usePersonalInfoFormStore = create<PersonalInfoFormState>(
  (set) => ({
    personalInfoForm: {
      firstName: "",
      lastName: "",
      address: "",
      contactNumber: "",
      email: "",
      identificationNumber: "",
      policyNumber: "",
      identificationType: "",
    },
    setPersonalInfoForm: (form) =>
      set((state) => ({
        personalInfoForm: {
          ...state.personalInfoForm,
          ...form,
        },
      })),
    resetPersonalInfoForm: () =>
      set(() => ({
        personalInfoForm: {
          firstName: "",
          lastName: "",
          address: "",
          contactNumber: "",
          email: "",
          identificationNumber: "",
          policyNumber: "",
          identificationType: "",
        },
      })),
  })
);
